import type { ApplicationRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ConsentService } from '../consent/consent.service';
import { ClarityService } from './clarity.service';

/**
 * Clarity: init only when analytics consent is granted; keep consent in sync when consent changes.
 */
export function initializeClarityWithConsent(applicationRef: ApplicationRef, projectId: string): void {
  const clarity = applicationRef.injector.get(ClarityService);
  const router = applicationRef.injector.get(Router);
  const consent = applicationRef.injector.get(ConsentService);

  let routerBound = false;

  const bindRouterIfReady = (): void => {
    if (routerBound || !clarity.isInitialized() || !clarity.analyticsAllowed()) {
      return;
    }
    routerBound = true;

    const sendRoute = (path: string): void => {
      const segment = path.split('/').filter(Boolean)[0] ?? '';
      void clarity.setTag('route', path);
      void clarity.setTag('page', segment || 'home');
      void clarity.event('page_view');
    };

    sendRoute(router.url);

    router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e) => {
      sendRoute(e.urlAfterRedirects);
    });
  };

  const run = (): void => {
    void (async () => {
      await clarity.syncStatisticsConsent(projectId, consent.analyticsAllowed());
      bindRouterIfReady();
    })();
  };

  run();
  consent.changed$.subscribe(() => run());
}
